import { CheckOutlined } from "@ant-design/icons";
import React from "react";
import variables from "../../themes/base/styles/variables";
import { Text, Space } from "react_reusable_components";
import Style from "./RenderDropDown.module.scss";

const RenderDropDown = (countryId, options, onClick) => (
  <>
    {options?.map((country) => (
      <Space
        key={country.id}
        onClick={() => onClick(country.id)}
        className={`${Style["dropdown-render-row-style"]}`}
      >
        <Text
          className={`${Style["select-item-style"]} ${
            Style[
              countryId?.length &&
                countryId?.includes(country.id) &&
                "select-item-active-style"
            ]
          }`}
        >
          {country.name}
        </Text>
        {!!countryId?.length && countryId?.includes(country.id) && (
          <CheckOutlined
            style={{ color: variables.primaryBg, fontSize: "1rem" }}
          />
        )}
      </Space>
    ))}
  </>
);

export default RenderDropDown;
